import type { SVGProps } from "react";
export interface StandardSdIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StandardSdIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StandardSdIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 7c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 21.125H5A4.125 4.125 0 0 1 .875 17V7A4.125 4.125 0 0 1 5 2.875h14A4.125 4.125 0 0 1 23.125 7z"
      />
      <path
        fill={color}
        d="M5.396 13.433a1.125 1.125 0 0 1 1.38.605l.042.107.051.125c.148.294.491.604 1.131.604.688 0 1.125-.502 1.125-.998 0-.201-.074-.376-.27-.55-.161-.144-.405-.281-.728-.384l-.348-.089c-.68-.136-1.432-.361-2.035-.8-.66-.48-1.12-1.207-1.119-2.174q0-.053.004-.105l.002-.004C4.695 7.994 6.358 6.875 8 6.875c1.66 0 2.778.962 3.234 2.05l.084.219.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.051-.125C8.983 9.436 8.64 9.125 8 9.125c-.825 0-1.124.516-1.125.75l-.001.004.001.002c0 .107.022.161.04.193.02.036.06.092.153.16.21.152.584.3 1.153.413l.279.063c1.4.36 2.875 1.351 2.875 3.165 0 1.854-1.562 3.25-3.375 3.25-1.658 0-2.778-.96-3.234-2.05l-.082-.22-.031-.11a1.124 1.124 0 0 1 .743-1.312m11.979-2.932c0-.76-.616-1.376-1.376-1.376h-.874v5.75h.874c.76 0 1.376-.615 1.376-1.374zm2.25 3a3.625 3.625 0 0 1-3.626 3.624h-1.748c-.76 0-1.376-.615-1.376-1.374v-7.5c0-.76.616-1.376 1.376-1.376h1.748a3.626 3.626 0 0 1 3.626 3.626z"
      />
    </svg>
  );
}
